var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bd9a9bd895f4a0dca2f08fbd0ff01f3865ecaafa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"bd9a9bd895f4a0dca2f08fbd0ff01f3865ecaafa"};
      